module.exports = __webpack_public_path__ + "img/10979921_L.9886b9c6.png";